<ngx-pin
  class="z-100 surface-elevated"
  [showBiometric]="false"
  [hasAnimation]="true"
  [enterPasswordState]="enterPasswordState()"
  [hint]="hint()"
  [disableActions]="pendingRequest"
  (onPinCompleted)="onEnter($event)"
  [title]="'رمز عبور خود را وارد نمایید'"
  #pinComponent
></ngx-pin>
